import { lineBreaksToNewLine } from 'lib/helpers';
import { htmlToPlainText } from 'shared-helpers/common';

import type { CalendarEvent } from 'shared-types';

const generateICalFile = (
  calendarEvent: Pick<
    CalendarEvent,
    'id' | 'description' | 'link' | 'title' | 'endDate' | 'startDate'
  >
) => {
  const uid = `${calendarEvent.id}@vuolearning`;
  // storing description/link for displaying if not null
  const descriptionParts: string[] = [];

  if (calendarEvent.description) {
    descriptionParts.push(calendarEvent.description);
  }
  if (calendarEvent.link) {
    descriptionParts.push(calendarEvent.link);
  }
  const description = htmlToPlainText(
    lineBreaksToNewLine(descriptionParts.join('\\n'))
  );
  const summary = calendarEvent.title;

  const now = new Date().toISOString().replace(/-|:|\.[0-9]{3}/g, '');
  const end = (calendarEvent.endDate as string).replace(/-|:|\.[0-9]{3}/g, '');
  const start = (calendarEvent.startDate as string).replace(
    /-|:|\.[0-9]{3}/g,
    ''
  );

  const calendarFile = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Vuolearning.fi//NONSGML v1//EN',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${now}`,
    `DTSTART:${start}`,
    `DTEND:${end}`,
    `SUMMARY:${summary}`,
    `DESCRIPTION:${description}`,
    'END:VEVENT',
    'END:VCALENDAR'
  ];

  return new Blob([calendarFile.join('\n')], { type: 'text/plain' });
};

export default generateICalFile;
